import React, {useContext} from 'react'
import { dataContext,localestr,beginMn,endMn, toText } from '../utils'
import Menu from '../cmp/menu'

function CatDevices4Viev({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    //const setWndData=actions.setWndData
    const context=useContext(dataContext)
    const msg=context.msg
    const msg2=context.msg2
    const inputRange=context.inputRange
    const inputNumber=context.inputNumber
    const loaddata=context.loaddata
    const addTWnd=context.addTWnd

    let from=new Date()
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)
    let rep_d=new Date()
    rep_d.setDate(rep_d.getDate()-5)

    const start_shift=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StartShift',screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const service_input=(sum,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ServiceInput',sum,screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const service_output=(sum,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ServiceOutput',sum,screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const x_report=(scr=false)=>{
        //console.log({id:wndData.id,command:'XReport',screen:scr})
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'XReport',screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const x_report_loc=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'XReportLoc',screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const close_shift=(scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'CloseShift',screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }
    
    const shifts_list=(d1,d2)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ShiftsList',from:d1,to:d2})
        loaddata('action=rroCommand&data='+dataJS,undefined,(data)=>printing(data,localestr('Перелік змін')))
    }

    const docs_list=(d1,d2)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'DocsList',from:d1,to:d2})
        loaddata('action=rroCommand&data='+dataJS,undefined,(data)=>printing(data,localestr('Перелік документів')))
    }

    const zrep_copy=(num,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'ZRepCopy',NumFiscal:num,screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const check_copy=(num,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'CheckCopy',NumFiscal:num,screen:scr})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const periodical_zrep=(d1,d2,scr=false)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'PeriodicalZRep',from:d1,to:d2,screen:scr})
        loaddata('action=rroCommand&data='+dataJS,undefined,()=>{})
    }

    const status_on=(d)=>{
        if(d){
            msg(d.data.replace(/<br>/g,"\n"),localestr('Статус в ДФС'),[{caption:'OK',action:()=>{}}])
            return
        }
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StatusOnline'})
        loaddata("action=rroCommand&data="+dataJS,undefined,status_on)
    }

    const status_of=(d)=>{
        if(d){
            msg(d.data.replace(/<br>/g,"\n"),localestr('Статус в пам\'яті'),[{caption:'OK',action:()=>{}}])
            return
        }
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'StatusOfline'})
        loaddata("action=rroCommand&data="+dataJS,undefined,status_of)
    }

    const terms=()=>{
        const str=localestr('Термін закінчення дії особистого ключа ')+toText(wndData.keyfile)+"\n"+localestr('Термін закінчення дії ліцензії на ПРРО ')+toText(wndData.licfile)
        msg(str,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
    }

    const set_totals=(sum)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'SetYearTotals',sum})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const tax_invoices=(d1,d2)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'taxInvoices',from:d1,to:d2})
        loaddata('action=rroCommand&data='+dataJS,undefined,(data)=>console.log(data))
    }
    
    const set_limit=(sum)=>{
        let dataJS=''
        dataJS=JSON.stringify({id:wndData.id,command:'SetYearLimit',sum})
        loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
    }

    const cor_check=(d,scr=false)=>{
        if(d) {
            let data={id:wndData.id,pay_form:d.payType,sum_pay:0,screen:scr}
            if(parseInt(d.checkType)===0) data.command='PutCheck'
            else {
                data.command='PutReturn'
                data.check_num=d.retNum
            }
            const doc_tbl=d.list.map(el=>{return {goods_id:el.menu.id,goods:el.menu.menu_name||el.menu.name,uktz:el.uktz,unit:el.unit?el.unit.name:'шт',qtt:parseFloat(el.sum_qtt),sum:parseFloat(el.sum_bruto),disc:parseFloat(el.sum_discount),vat:null,excise:el.excise,excise_mark:el.excise_mark}})
            data.doc_tbl=doc_tbl
            const dataJS=JSON.stringify(data)
            loaddata("action=rroCommand&data="+dataJS,undefined,()=>{})
        }
        else addTWnd(localestr('Коригувальний чек'),'serv_check',(data)=>prn_req((p)=>cor_check(data,p)),{fiscal:wndData,checkType:'0',payType:'0',list:[]})
    }
    
    const printing=(data,caption,layer=false)=>{
        if(data.status==='OKPrint'){
            if(!data.data) return
            const items=data.data.map((col,idx)=>{
                const rows=col.map((row,id)=>{
                    if(row.action) return <div key={idx+'_'+id} style={row.style} onDoubleClick={()=>specification(row.action)}>{row.text}</div>
                    else return <div key={idx+'_'+id} style={row.style}>{row.text}</div>
                })
                return <div key={idx} style={{display:'flex',flexDirection:'row'}}>{rows}</div>
            })
            const cont=<div style={{display:'flex',flexDirection:'column',width:'90mm'}}>{items}</div>
            if(layer) msg2(cont,caption)
            else msg(cont,caption)
        }
        //console.log(data)
    }

    const prn_req=(act)=>{
        if(!wndData.Printer_id) return act(true)
        msg(localestr('Куди вивести результат?'),localestr('Запитання'),[{caption:localestr('Екран'),action:()=>act(true)},{caption:localestr('Принтер'),action:()=>act()},{caption:localestr('Відмінити'),action:()=>{}}])
        //act(true)
    }

    const specification=(obj)=>{
        if(!obj) return
        if(obj.act==='ZRepCopy') prn_req((p)=>zrep_copy(obj.NumFiscal,p))
        if(obj.act==='CheckCopy') prn_req((p)=>check_copy(obj.NumFiscal,p))
        //else console.log(obj.act)
        //console.log(obj)
        //msg2(obj.act)
    }


    const menuData=[
        {name:localestr('Термін дії ключа/ліцензії'),action:terms},
        {name:localestr('Статус локальний'),action:()=>{status_of()}},
        {name:localestr('Статус онлайн'),action:()=>{status_on()}},
        {name:localestr('Денний Х звіт офлайн'),action:()=>prn_req(p=>x_report_loc(p))},
        {name:localestr('Податкові накладні'),action:()=>{
    msg(localestr("Для формування податкових накладних необхідно завантажити\nз порталу ДФС всі чеки. Це може зайняти тривалий час\nабо призвести до зависання.\nСтавтесь відповідально при виборі періоду!"),localestr('Попередження'),[{caption:localestr('ОК'),action:()=>inputRange(from,to,tax_invoices)},{caption:localestr('Відмінити'),action:()=>{}}])
        }},
        {name:localestr('Службовий чек'),action:cor_check},
        {name:localestr('Скоригувати річний оборот'),action:()=>inputNumber(localestr('Новий оборот'),localestr('Сума'),0,s=>set_totals(s))},
        {name:localestr('Скоригувати річний ліміт'),action:()=>inputNumber(localestr('Новий ліміт'),localestr('Сума'),0,s=>set_limit(s))},
        //{name:localestr('Вийти з офлайн'),icon:'#hisBut',action:()=>{}},
        //{name:localestr('Перенумерувати пакет'),icon:'#hisBut',action:()=>{}},
        //{name:localestr('Перейти в офлайн'),icon:'#hisBut',action:()=>{}},
    ]

    //---термінал
    function clear_msg(msg){
        if (!msg) return ''
        let str=msg
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<div\b[^>]*>(.*?)<\/div>/g, ' $1 ')
        str = str.replace(/<br\/>/g, "\n")
        str = str.replace(/ {5,10}/g, "\n")
        str = str.replace(/ {2,10}/g, ' ')
        str = str.replace(/\n{2,10}/g, "\n")
        return str
    }

    function obj_to_str(obj){
        let str=''
        for (const [key, value] of Object.entries(obj)) {
            str+="\n"+key+' - '+value
        }
        return str
    }

    function ws_resp(d){
        if ( d['status'] === 'ok') {
            if(d['method'] === 'ServiceMessage'){
                if(d['error']) msg(d['errorDescription'],localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                else if(d['params']['msgType']==='getMerchantList') msg(obj_to_str(d['params']),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
                else msg(d['params']['msgType'],localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            }
            if(d['method'] === 'Audit') msg(clear_msg(d['params']['receipt']),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            if(d['method'] === 'CheckConnection'){
                if(d['error']) msg(d['errorDescription'],localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                else msg(localestr('З\'єднання встановлено успішно!'),localestr('Повідомлення'),[{caption:'OK',action:()=>{}}])
            } 
        } else if (d['status'] === 'error')  msg(d['message'],localestr('Помилка'),[{caption:'OK',action:()=>{}}])
    }
    
    function ws_open() {
        if(context.ws) {
            return
        }
        context.ws=(new WebSocket("ws://"+wndData.ip+":"+wndData.port+"/echo"))
        context.ws.onopen = function() {}
        context.ws.onclose = function(evt) {
            context.ws = null
        }
        context.ws.onmessage = function(evt) {
            ws_resp(JSON.parse(evt.data));
        }
        context.ws.onerror = function(evt) {
            console.log("ERROR: " + evt.data)
        }
    }
        
    function ws_close() {
        if(!context.ws) {
            return false
        }
        context.ws.close(1000)
        return false
    }
    
    function check_con(cnt=0){
        ws_open()
        if(!context.ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1){
            setTimeout(()=>check_con(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'CheckConnection',
            step: 0,
            params: {
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        context.ws.send(j)
        setTimeout(ws_close,15000)
    }

    function x_balance(cnt=0){
        ws_open()
        if(!context.ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1){
            setTimeout(()=>x_balance(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'XReport',
            step: 0,
            params: {
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        context.ws.send(j)
        setTimeout(ws_close,15000)
    }

    function merch_list(cnt=0){
        ws_open()
        if(!context.ws){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1&&cnt>10){
            msg(localestr('Відсутнє з\'єднання!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        if(context.ws.readyState!==1){
            setTimeout(()=>merch_list(cnt+1),300)
            return
        }
        let j = JSON.stringify({
            method: 'MerchantList',
            step: 0,
            params: {
                msgType: 'getMerchantList',
                groupId: wndData.groupId ?? null,
                groupList: wndData.terminalGroups
            }
        })
        context.ws.send(j)
        setTimeout(ws_close,15000)
    }
    
    let terminal=null
    if(wndData.ip && wndData.port){
        const menuTerm=[
            {name:localestr('Перевірка звязку з банком'),action:()=>{check_con()}},
            {name:localestr('Х баланс'),action:()=>x_balance()},
            {name:localestr('Список доступних компаній '),action:()=>{merch_list()}},
        ]
        terminal=<div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'30px',lineHeight:'30px',display:'block'}}><Menu stl={{height:'unset',position:'absolute',width:'calc(100% - 18px)'}} data={menuTerm} left={true}>{localestr('Платіжний термінал')}</Menu></div></div>
    }

    return(
        <div className='no-print' style={{display:'flex',flexDirection:'column', margin:'4px 0'}}>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req(p=>start_shift(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Відкрити зміну')}</div></div>
        <div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'116px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>inputNumber(localestr('Введіть суму'),localestr('Сума'),0,s=>prn_req(p=>service_input(s,p)))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Внесення')}</div></div>
        <div style={{width:'116px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>inputNumber(localestr('Введіть суму'),localestr('Сума'),0,s=>prn_req(p=>service_output(s,p)))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Видача')}</div></div>
        </div>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req(p=>x_report(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Денний Х звіт')}</div></div>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>prn_req(p=>close_shift(p))}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Фіскальний Z звіт')}</div></div>
        <div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'116px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(from,to,shifts_list)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Реєстр змін')}</div></div>
        <div style={{width:'116px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(from,to,docs_list)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Реєстр чеків')}</div></div>
        </div>
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputRange(beginMn(rep_d),endMn(rep_d),(d1,d2)=>prn_req(p=>periodical_zrep(d1,d2,p)))}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Періодичний звіт')}</div></div>
        {terminal}
        <div style={{width:'244px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'30px',lineHeight:'30px',display:'block'}}><Menu stl={{height:'unset',position:'absolute',width:'calc(100% - 18px)'}} data={menuData} left={true}>{localestr('Додатково')}</Menu></div></div>
        </div>
    )

}

export default CatDevices4Viev